const createQuoteAddonSelection = () => {
  let seededQuoteId = null;
  const isSeeded = quoteId =>
    Boolean(quoteId) && seededQuoteId === String(quoteId);

  const override = quoteId => {
    if (quoteId) seededQuoteId = String(quoteId);
  };

  const seed = (quoteId, data) => {
    if (!quoteId || !data || isSeeded(quoteId)) return {};
    let ids = data.selected_addon_fee_ids;
    let quantities = data.selected_addon_quantities;
    if (!Array.isArray(ids)) {
      if (!Array.isArray(data.line_items)) return {};
      const optionalFees = data.line_items.filter(
        item => item.item_type === 'fees' && item.optional
      );
      if (
        optionalFees.some(
          item => !item.additional_data || !item.additional_data.fee_id
        )
      )
        return {};
      ids = optionalFees.map(item => item.additional_data.fee_id);
      quantities = optionalFees.map(item => ({
        id: item.additional_data.fee_id,
        quantity: item.additional_data.quantity || 1
      }));
    }
    const feeQuantities = ids.map(id => {
      const saved = (quantities || []).find(
        item => Number(item.id) === Number(id)
      );
      return { id: Number(id), quantity: saved ? Number(saved.quantity) : 1 };
    });
    const addonFeeIds = [];
    feeQuantities.forEach(({ id, quantity }) => {
      for (let count = 0; count < quantity; count += 1) addonFeeIds.push(id);
    });
    override(quoteId);
    return { addonFeeIds, feeQuantities };
  };

  const pricingIds = (quoteId, ids) => {
    if (!quoteId) return ids;
    if (!isSeeded(quoteId)) return undefined;
    return ids.length ? ids : '';
  };

  return { seed, isSeeded, override, pricingIds };
};

module.exports = { createQuoteAddonSelection };
